/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field__Enum_Schoolname_Internatsschule_Schloss_Hansenberg4Inputs */

const en__field__enum_schoolname_internatsschule_schloss_hansenberg4 = /** @type {(inputs: _Field__Enum_Schoolname_Internatsschule_Schloss_Hansenberg4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geisenheim-Johannisberg`)
};

const de__field__enum_schoolname_internatsschule_schloss_hansenberg4 = /** @type {(inputs: _Field__Enum_Schoolname_Internatsschule_Schloss_Hansenberg4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Internatsschule Schloss Hansenberg`)
};

/**
* | output |
* | --- |
* | "Geisenheim-Johannisberg" |
*
* @param {_Field__Enum_Schoolname_Internatsschule_Schloss_Hansenberg4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field__enum_schoolname_internatsschule_schloss_hansenberg4 = /** @type {((inputs?: _Field__Enum_Schoolname_Internatsschule_Schloss_Hansenberg4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field__Enum_Schoolname_Internatsschule_Schloss_Hansenberg4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field__enum_schoolname_internatsschule_schloss_hansenberg4(inputs)
	return de__field__enum_schoolname_internatsschule_schloss_hansenberg4(inputs)
});
export { _field__enum_schoolname_internatsschule_schloss_hansenberg4 as "_field__enum_schoolName_Internatsschule_Schloss_Hansenberg" }